import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, List } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  duplicateList(request: Boundaries["duplicateList"]["request"]): void;
}

function useDuplicateList(list: Identifiable<List>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDuplicateListRequestPending(list),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDuplicateListRequestSuccess(list),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDuplicateListRequestFailure(list),
    ),
    duplicateList: core.duplicateList,
  };
}

export { useDuplicateList };
